import { render } from "./RiChatbot.vue?vue&type=template&id=51335db2"
import script from "./RiChatbot.vue?vue&type=script&lang=js"
export * from "./RiChatbot.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiChatbot.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "51335db2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('51335db2', __exports__)) {
    api.reload('51335db2', __exports__)
  }
  
  module.hot.accept("./RiChatbot.vue?vue&type=template&id=51335db2", () => {
    api.rerender('51335db2', render)
  })

}


export default __exports__